/**
 * 路由配置信息
 *
 * @author terrfly
 * @site https://www.techpayx.vip
 * @date 2021/5/8 07:18
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

// hack router push callback
// [解决 vue-router跳转相同路径报错 ]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [
  {path: '/hub/:techpayxToken?', name: 'Hub', component: () => import('../views/Hub.vue')}, //自动分发器
  {path: '/error', name: 'Error', component: () => import('../views/Error.vue')},
  {path: '/apps', name: 'Apps', component: () => import('../views/Apps.vue')}, //商家应用聚合页（无需白名单/鉴权）
  {path: '/mis-cashier/:token?', name: 'MisCashier', component: () => import('../views/MisCashier.vue')}, //智能POS 云MIS 小型收银台（店铺员工用，token 走路径，风格同 /hub/:token）
  {path: '/oauth2Callback/:techpayxToken?', name: 'Oauth2Callback', component: () => import('../views/Oauth2Callback.vue')}, //oauth回调地址
  {path: '/cashier', name: 'Cashier', component: () => import('../views/Cashier.vue'), //收银台（该地址无意义）
    children: [
        { path: '/cashier/index', name: 'CashierIndex', component: () => import('../views/payway/Index') },
        { path: '/cashier/wxpay', name: 'CashierWxpay', component: () => import('../views/payway/Wxpay.vue') },
        { path: '/cashier/wxpay-fixed', name: 'CashierWxpayFixed', component: () => import('../views/payway/FixedPay.vue'), meta: { payType: 'wxpay' } },
        { path: '/cashier/alipay', name: 'CashierAlipay', component: () => import('../views/payway/Alipay.vue') },
        { path: '/cashier/alipay-fixed', name: 'CashierAlipayFixed', component: () => import('../views/payway/FixedPay.vue'), meta: { payType: 'alipay' } },
        { path: '/cashier/ysfpay', name: 'CashierYsfpay', component: () => import('../views/payway/Ysfpay.vue') },
        { path: '/cashier/ysfpay-fixed', name: 'CashierYsfpayFixed', component: () => import('../views/payway/FixedPay.vue'), meta: { payType: 'ysfpay' } },
        { path: '/cashier/invoice', name: 'CashierInvoice', component: () => import('../views/payway/Invoice.vue') },
        // 微信点金计划：支付成功后使用 location.replace 全路径打开，勿删；需在商户平台配置白名单
        { path: '/cashier/wxpay-pay-success', name: 'CashierWxpayPaySuccess', component: () => import('../views/payway/WxpayPaySuccess.vue') },
        // 视频号引流落地页：经点金计划 jumpOut(h5) 打开，内含开放标签拉起小程序再跳视频号；域名需加入服务号 JS 安全域名
        { path: '/cashier/channels-launch', name: 'CashierChannelsLaunch', component: () => import('../views/payway/ChannelsLaunch.vue') },
        // 微信支付参数调试页（仅供测试，勿上线）
        { path: '/cashier/wxpay-test', name: 'CashierWxpayTest', component: () => import('../views/payway/WxpayTest.vue') },
        // 交易测试页：手动填写微信/支付宝/云闪付支付参数，调试 JSBridge 拉起支付（仅供测试，勿上线）
        { path: '/cashier/transaction-test', name: 'CashierTransactionTest', component: () => import('../views/payway/TransactionTest.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history', // history 模式，URL 更美观，需要服务器配置支持
  base: "",
  routes
})

export default router
